import React from 'react';
// import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { Col, Row, Alert } from 'reactstrap';
import { Modal } from 'antd';
// Local Deps
import './EditInventoryManagement.scss';
import InventoryManagementDefinitionForm from '../../forms/InventoryManagementDefinitionForm';
import EditInventoryManagementHOC from './EditInventoryManagementHOC';

function EditInventoryManagement(props) {
  const { onSubmit, formValues, type, message, handleInitalValueReset, closeEditModal, showEditModal } = props;
  return (
    <Modal
      title={<h3>Edit Inventory Management</h3>}
      visible={showEditModal}
      width="fit-content"
      footer={null}
      onCancel={closeEditModal}
    >
      <Col style={{ display: 'flex', justifyContent: 'center' }}>
        {message && <Alert color={type}>{message}</Alert>}
      </Col>
      <Row>
        {/* <!-- FORM --> */}
        <div className="nf-edit-tool__form">
          <InventoryManagementDefinitionForm
            onSubmit={onSubmit}
            initialValues={formValues}
            handleInitalValueReset={handleInitalValueReset}
            closeEditModal={closeEditModal}
          />
        </div>
      </Row>
    </Modal>
  );
}

EditInventoryManagement.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.object.isRequired,
  handleInitalValueReset: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  showEditModal: PropTypes.bool.isRequired,
  closeEditModal: PropTypes.func.isRequired,
};

export default EditInventoryManagementHOC(EditInventoryManagement);



// WEBPACK FOOTER //
// ./src/components/Modals/EditInventoryManagement/EditInventoryManagement.jsx